<div class="hidden md:block h-screen text-white rounded-tr-2xl rounded-br-2xl py-8 pl-4 bg-primary"
[ngStyle]="{ width: isCollapsed ? '80px' : '256px', transition: 'all 400ms ease' }"
(click)="onNavClick($event)"
(keydown)="onKeyDown($event)"
(keyup)="onKeyUp($event)">
    <div class="flex">
        <div class="grow"></div>
        <button mat-icon-button (click)="toggleCollapse()"
            class="nav-collapse-button h-7 w-8 flex items-center justify-center rounded-l-lg">
            @if (isCollapsed) {
                <mat-icon svgIcon="nav-arrow-right"></mat-icon>
            } @else {
                <mat-icon svgIcon="nav-arrow-left"></mat-icon>
            }
        </button>
    </div>
    <div class="flex flex-col h-full overflow-hidden pr-4 pb-7">
        <!-- T-PRO Logo -->
        <div class="flex items-center h-14 p-2 mb-6">
            <ng-container *ngIf="!isCollapsed; else compactLogo">
                <div class="flex flex-col">
                    <div class="flex items-center gap-2.5">
                        <img [src]="branding.logoSrc" alt="Logo" class="h-7 w-auto overflow-hidden" />
                        <div *ngIf="branding.showScribeWordmark" class="title-medium tpro-gradient">Scribe</div>
                    </div>
                    <div *ngIf="branding.showPoweredByTpro" class="label-medium text-white text-right mt-1">
                        {{ 'powered by T-Pro' | translate }}
                    </div>
                </div>
            </ng-container>
            <ng-template #compactLogo>
                <div class="flex w-full justify-center">
                    <mat-icon [svgIcon]="branding.logoCompactIcon"></mat-icon>
                </div>
            </ng-template>
        </div>

        <!-- Top Nav Items -->
        <div class="pb-4">
            <div class="flex flex-col gap-2 mb-6">
                <a routerLink="/home" routerLinkActive="active" class="nav-menu-item" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
                    <mat-icon svgIcon="home"></mat-icon>
                    <div *ngIf="!isCollapsed">{{ 'Home' | translate }}</div>
                </a>
                <a routerLink="/encounters" routerLinkActive="active" class="nav-menu-item" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
                    <mat-icon svgIcon="encounters"></mat-icon>
                    <div *ngIf="!isCollapsed">{{ 'Encounters' | translate }}</div>
                </a>
            </div>
            <!-- Divider -->
            <ng-container *ngTemplateOutlet="divider"></ng-container>
        </div>
        

        <!-- Spacer to push footer -->
        <div class="flex-grow"></div>

        <!-- Footer -->
        <div class="flex flex-col gap-6">
            <!-- Bottom Nav Items -->
                <div class="flex flex-col gap-2">
                    <a *ngIf="isAiBlueprintsEnabled" routerLink="/ai-blueprints" routerLinkActive="active" class="nav-menu-item" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
                        <mat-icon svgIcon="ai-blueprints"></mat-icon>
                        <div *ngIf="!isCollapsed">{{ 'AI blueprints' | translate }}</div>
                    </a>
                    <a *ngIf="showMdrInformation" routerLink="/information" routerLinkActive="active" class="nav-menu-item" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
                        <mat-icon svgIcon="info-circle"></mat-icon>
                        <div *ngIf="!isCollapsed">{{ 'MDR information' | translate }}</div>
                    </a>
                    <a [href]="supportUrl" target="_blank" class="nav-menu-item" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'" (click)="onSupportClick()">
                        <mat-icon svgIcon="support"></mat-icon>
                        <div *ngIf="!isCollapsed">{{ 'Support' | translate }}</div>
                    </a>
                    <a routerLink="/settings" routerLinkActive="active" class="nav-menu-item" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
                        <mat-icon svgIcon="settings"></mat-icon>
                        <div *ngIf="!isCollapsed">{{ 'Settings' | translate }}</div>
                    </a>
                    <button (click)="onLogout()" class="nav-menu-item cursor-pointer" [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
                        <mat-icon class="material-symbols-outlined material-symbols-wght-300">logout</mat-icon>
                        <div *ngIf="!isCollapsed">{{ 'Logout' | translate }}</div>
                    </button>
                </div>

            <!-- Divider -->
            <ng-container *ngTemplateOutlet="divider"></ng-container>

            <!-- Account -->
            <div class="flex items-center h-17 w-full rounded-md p-2"
            [ngClass]="isCollapsed ? 'justify-center' : 'justify-between'">
                <div class="size-10 rounded-full shrink-0 overflow-hidden flex items-center justify-center">
                    @if (avatarUrl) {
                    <img [src]="avatarUrl" alt="avatar" class="w-full h-full object-cover rounded-full" />
                    } @else {
                    <mat-icon svgIcon="user-circle" class="icon-size [--icon-size:100%] [--icon-stroke-width:0.8px] text-inverse-on-surface"></mat-icon>
                    }
                </div>
                <div class="text-inverse-on-surface flex-grow flex flex-col overflow-hidden ml-4" *ngIf="!isCollapsed">
                    <div class="label-large-prominent whitespace-nowrap overflow-hidden text-ellipsis text-left" style="font-family: DM Sans, sans-serif">
                        {{ user?.profile?.name || 'User' }}</div>
                    <div class="label-medium overflow-hidden text-ellipsis text-left" style="font-family: DM Sans, sans-serif">
                        {{ user?.entity?.name || '' }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #divider>
    <div class="h-px w-full bg-[#f5fafd1f]"></div>
</ng-template>